import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

import CheckIcon from 'images/check.svg'

const MissionBlockEditModal = ({ closeModal, translate }) => (
  <Modal closeModal={closeModal} size='md' className='mission-block-edit-modal'>
    <img src={CheckIcon} />
    <h3>
      <strong>
        {translate('stockTransfer.missionBlock.successModal.title')}
      </strong>
    </h3>
    <em>{translate('stockTransfer.missionBlock.successModal.text')}</em>
    <Row className='margin-top-quadruple'>
      <Col xs={4} xsOffset={4}>
        <button
          onClick={closeModal}
          className='button button-primary button-full'
        >
          {translate('ok_button')}
        </button>
      </Col>
    </Row>
  </Modal>
)

MissionBlockEditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default MissionBlockEditModal
